export default {
  BusinessBatchInventoryQuery: {
      header: {
        // spuCode: '商品编码',
        // spuName: '商品名称',
        warehouseCode: '仓库编码',
        warehouseId: '仓库名称',
        skuCode: 'SKU编码',
        categoryIdList: '商品分类',
        warehouseTypeCode: '仓库类型',
        exceedZero: '可用量是否大于0'
      },
  
      table: {
        // spuCode: '商品编码',
        // spuName: '商品名称',
        skuCode: 'SKU编码',
        warehouseCode: '仓库编码',
        warehouseName: '仓库名称',
        orderNumber:"订单号",
        ShipmentSKUCode:"发货skuCode",
        expirationDate:"过期日期",
        usableNum: '可用库存',
        stockNum: '在库库存',
        lockNum: '锁定库存',
        wayNum: '在途库存',
        preemptionNum: '预占库存',
        waitNum: '待收库存',
        reservedNum: '预留库存',
        typeCode: '仓库类型',
        categoryName: '商品分类',
        brandName: '品牌名称',
        usableNum2: '可用量',
        stockNum2: '在库量',
        lockNum2: '锁定量',
        changeNum: '变量',
        pallet: '板类型',
        exportFileName: '库存清单'
      }
    }
  };
  